import { useQuery } from 'react-query';
import { getDemandPositions, GetDemandPositionsParams } from '../services/demandService';
import { useAppSession } from '../contexts/AppSessionContext';

export const useDemandPositions = (params: GetDemandPositionsParams = {}) => {
  const { user } = useAppSession();
  const accountId = user?.accountId;
  
  return useQuery(
    ['demand-positions', accountId, params],
    () => getDemandPositions({ ...params, accountId: accountId ? parseInt(accountId) : undefined }),
    {
      enabled: !!accountId,
      staleTime: 30000, // 30 seconds
      refetchOnWindowFocus: false,
    }
  );
};
